import { z } from "zod";

export const PatientSchema = z.object({
  id: z.string(),
  first_name: z.string(),
  last_name: z.string(),
  dob: z.string().optional(), 
  contact_number: z.string().optional(), 
  is_new_pt: z.string().optional(), 
  last_seen_did: z.union([z.string(), z.null()]).optional(), 
});

export const PatientStatusSchema = z.object({
  banned_level: z.number(),
  banned_msg: z.union([z.string(), z.null()]),
});

export const PatientAppointmentSchema = z.object({
  location_id: z.string(),
  appointment_type_id: z.string(),
  doctor_id: z.string(),
  date: z.string(),
  time: z.string(),
  duration: z.string().optional(),
  status: z.string().optional(),
});
